import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 1 }

import { ref } from 'vue'
import { businessList, businessDelete, businessDetails } from '@/api/gucangSales/chanceManage'
import dataConfig from '@/views/gucangSales/commonEnum/dataConfig'
import BusinessName from '@/components/BusinessName/index.vue'
import Modal from '@/hooks/modalType'
import { useRoute, useRouter } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import { BusinessListItem } from '@/typings/api/chanceManage'
import { tableIdByPath } from '@/utils'

const __default__ = { name: 'tabsBusiness' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  edit: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: true
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  arkCodeId: {
    type: String
  }
},
  setup(__props) {

const router = useRouter()
const route = useRoute()
const tableRef = ref()
const props = __props
const fetch = (queryForm: object, callBack: (res: any) => void) => {
  if (route.query.cosId) {
    businessList({
      arkCodeId: props.arkCodeId,
      saleChanceRefId: route.query.cosId as string,
      ...queryForm
    }).then((res) => {
      callBack(res)
    })
  } else {
    setTimeout(() => {
      callBack([])
    }, 500)
  }
}
const showMask = (record: BusinessListItem, callBack: (res: any) => void) => {
  businessDetails({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}
// 编辑
const handleEdit = (row: BusinessListItem) => {
  router.push({
    path: '/fbu/business/edit',
    query: {
      id: row.id,
      returnPath: route.fullPath
    }
  })
}
// 删除
const handleDelete = (row: BusinessListItem) => {
  Modal.delete({
    name: row.saleChanceNameByTxt,
    onOk() {
      businessDelete({ id: row.id }).then(() => {
        message.success('删除商机成功')
        tableRef.value.delFetch()
      })
    }
  })
}
const columns = ref([
  { title: '商机名称', dataIndex: 'saleChanceName', fixed: 'left', width: 200 },
  { title: '子客户代码', dataIndex: 'arkCode' },
  { title: '联系人姓名', dataIndex: 'contactName', cosType: 'mask' },
  { title: '手机号', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: '预计月销售额(万)', dataIndex: 'planSaleAmount', width: 150 },
  { title: '商机创建时间', dataIndex: 'createTime', width: 190 },
  { title: '商机阶段', dataIndex: 'status', dicData: dataConfig.businessStatusEnum },
  { title: '操作', dataIndex: 'action', fixed: 'right' }
])

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_cos_table, {
    columns: columns.value,
    onFetch: fetch,
    onMask: showMask,
    tableId: _unref(tableIdByPath)('business'),
    ref_key: "tableRef",
    ref: tableRef,
    rowKey: "id"
  }, {
    bodyCell: _withCtx(({ column, record }) => [
      (column.dataIndex === 'saleChanceName')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: '/fbu/business/view?id=' + record.id,
            title: record.saleChanceNameByTxt
          }, {
            default: _withCtx(() => [
              (record.saleChanceName)
                ? (_openBlock(), _createBlock(BusinessName, {
                    key: 0,
                    appId: "cos_fbu",
                    value: record.saleChanceName,
                    "onUpdate:value": ($event: any) => ((record.saleChanceName) = $event),
                    label: record.saleChanceNameByTxt,
                    "onUpdate:label": ($event: any) => ((record.saleChanceNameByTxt) = $event)
                  }, null, 8, ["value", "onUpdate:value", "label", "onUpdate:label"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_1, "--"))
            ]),
            _: 2
          }, 1032, ["to", "title"]))
        : _createCommentVNode("", true),
      (column.dataIndex === 'action')
        ? (_openBlock(), _createBlock(_component_MoreButton, { key: 1 }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                workCode: record.dutyBy,
                type: "link",
                onClick: ($event: any) => (handleEdit(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("编辑")
                ]),
                _: 2
              }, 1032, ["workCode", "onClick"])), [
                [_directive_permission, __props.permissionPage?.edit]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleDelete(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, __props.permissionPage?.del]
              ])
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["columns", "tableId"]))
}
}

})